import { makeStyles } from 'tss-react/mui'
import Noise from 'src/assets/images/campaigns/noise.png'

const useStyles = makeStyles()((theme) => ({
  container: {
    width: '100%',
    maxWidth: theme.maxWidth,
    padding: theme.spacing(0, 17.5, 0, 13.5),
    margin: theme.spacing(40, 0),
    marginLeft: 'auto !important',
    marginRight: 'auto !important',
    [theme.breakpoints.down('md')]: {
      padding: theme.spacing(0, 4),
    },
  },
  containerWithNotMargin: {
    width: '100%',
    maxWidth: theme.maxWidth,
    padding: theme.spacing(0, 17.5, 0, 17.5),

    [theme.breakpoints.down('md')]: {
      padding: theme.spacing(0, 4),
    },
    margin: 'auto',
  },
  volunteerFormComp: {
    width: '100%',
    borderRadius: '40px',

    background: `url(${Noise.src})`,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    [theme.breakpoints.down('md')]: {
      borderRadius: '20px',
    },
  },
  volunteerFormInner: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    padding: theme.spacing(4, 14),
    background:
      'linear-gradient(0deg, rgba(255,255,255,1) 0%, rgba(255,255,255,0.2) 10%, rgba(255,255,255,0) 100%)',
    [theme.breakpoints.down('md')]: {
      padding: theme.spacing(0, 4),
    },
  },
  textContainer: {
    width: '100%',
    textAlign: 'center',
    margin: theme.spacing(12, 0, 0),
  },
  volunteerFormHeading: {
    fontFamily: 'Nunito Sans',
    fontStyle: 'normal',
    fontWeight: 800,
    fontSize: '64px',
    lineHeight: '83px',
    textTransform: 'uppercase',
    color: theme.custom.blackColor,
    padding: theme.spacing(2, 0),
    [theme.breakpoints.down('md')]: {
      fontSize: '44px',
      lineHeight: '53px',
    },
  },
  volunteerFormSubHeading: {
    fontFamily: 'Lato',
    fontStyle: 'normal',
    fontWeight: 400,
    fontSize: '32px',
    lineHeight: '28px',
    padding: theme.spacing(2, 0),
  },
  volunteerFormBodyText: {
    padding: theme.spacing(4, 0, 12, 0),
    background: 'transparent',
  },
  formContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: theme.spacing(12),
  },
  formInnerContainer: {
    width: '100%',
    maxWidth: '950px !important',
    backgroundColor: '#fff',
    padding: theme.spacing(0, 4),
    borderRadius: theme.spacing(4),
  },
}))

export default useStyles
